export enum MeetingType {
  INVESTMENT_COMMITTEE = "Investment Committee",
  PIPELINE_REVIEW = "Pipeline Review",
  MEETING = "Meeting",
}

export enum MeetingSubtype {
  CALL = "Call",
  IN_PERSON = "In-Person",
}
